import i18n from '../i18n'
import { getPasswordStrength, isPasswordStrongEnough } from './passwordRules'

export function validateEmail(value: string): string | null {
  const t = i18n.getFixedT(null, 'common')
  const trimmed = value.trim()
  if (!trimmed) return t('validation.emailRequired')
  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmed)) {
    return t('validation.emailInvalid')
  }
  return null
}

export function validatePassword(
  value: string,
  options?: { minLength?: number; forRegistration?: boolean },
): string | null {
  const t = i18n.getFixedT(null, 'common')
  if (!value) {
    return options?.forRegistration
      ? t('validation.passwordCreate')
      : t('validation.passwordRequired')
  }

  if (options?.forRegistration) {
    // Same rules as Account Settings → Password & Security
    if (value.length < 8) {
      return t('validation.passwordMinLength', { min: 8 })
    }
    if (getPasswordStrength(value) === 'weak' || !isPasswordStrongEnough(value)) {
      return t('validation.passwordTooWeak')
    }
    return null
  }

  const min = options?.minLength ?? 0
  if (min > 0 && value.length < min) {
    return t('validation.passwordMinLength', { min })
  }
  return null
}

export function validatePasswordConfirmation(
  password: string,
  confirmPassword: string,
): string | null {
  const t = i18n.getFixedT(null, 'common')
  if (!confirmPassword) {
    return t('validation.passwordConfirmRequired')
  }
  if (password !== confirmPassword) {
    return t('validation.passwordMismatch')
  }
  return null
}

export function validateName(value: string, label: string): string | null {
  const t = i18n.getFixedT(null, 'common')
  if (!value.trim()) return t('validation.nameRequired', { label })
  return null
}

export function validateTermsAccepted(accepted: boolean): string | null {
  const t = i18n.getFixedT(null, 'common')
  if (!accepted) return t('validation.termsRequired')
  return null
}

export function focusFirstField(fieldIds: Record<string, string>, errors: Record<string, string>) {
  const firstKey = Object.keys(errors)[0]
  if (!firstKey) return
  const id = fieldIds[firstKey]
  if (!id) return
  document.getElementById(id)?.focus()
}
